import constants from './en';

// All Global Constants and Enum Types should be stored here
const AppDefaults = {
  ALL_LOCATIONS_ID: 'Location0',
  ERR_CANCELED: 'ERR_CANCELED',
  CAMERA_VIDEO_TIMELINE_MAX_DURATION_IN_SECONDS: 300,
  // Max mumber of ticks on tImeline
  CAMERA_VIDEO_TIMELINE_MAX_NUMBER_OF_TICKS: 46.5,
  // Number of seconds per tick
  CAMERA_VIDEO_TIMELINE_NUMBER_OF_SECONDS_PER_TICK: 6,
  // Min Duration: 10 seconds
  INCIDENT_EVIDENCE_CLIP_MIN_DURATION_IN_SECONDS: 10,
  // Max Duration: 240 seconds
  INCIDENT_EVIDENCE_CLIP_MAX_DURATION_IN_SECONDS: 240,
  // Default Duration: 30 seconds
  INCIDENT_EVIDENCE_CLIP_DEFAULT_DURATION_IN_SECONDS: 30,
  // Width of clipper handle in pixels
  INCIDENT_EVIDENCE_CLIP_HANDLE_WIDTH: 10,
  INCIDENT_EVIDENCE_SUPPORTED_FILE_EXTENSIONS:
    '.pdf,.doc,.docx,.jpeg,.jpg,.png,.raw,.mp4,.zip',
  INCIDENT_EVIDENCE_FILE_MAX_SIZE: 10,
  INCIDENT_DATE_FORMAT: 'll',
  INCIDENT_EVIDENCE_NOTE_DATE_FORMAT: 'lll',
  INCIDENT_EVIDENCE_NOTE_ORIGINAL_VIDEO_FILENAME_RETAINED: false,
  INCIDENT_FINAL_ANALYSIS_MAX_CHARACTERS: 1000,
  PROJECT_DUCLO: 'DUCLO',
  PROJECT_MEGATRON: 'MEGATRON',
  CAMERAS_VIDEO_WALL_MAX_VIEW_DEVICES_COUNT: 12,
  ORG_TYPE_CUSTOMER: 'CUSTOMER_ORG',
  ORG_TYPE_INSTALLER: 'INSTALLER_ORG',
  DEFAULT_TIMER_TIME: 1800000,
  DATA_TYPE_DATE: 'date',
  ONEGB: 1024,
  POS_FILE_EXTENSIONS: '.csv,.xls',
  POS_DEFUALT_STORE_ID: 'POS-STORE0',
  POS_STATUS_FAILED: 'FAILED',
  POS_STATUS_IN_PROGRESS: 'IN_PROGRESS',
  POS_STATUS_COMPLETED: 'COMPLETED',
  POS_STATUS_STALLED: 'STALLED',
  FROM_TOS_PP: 3,
  FROM_TOS: 1,
  FROM_PP: 2,
  NOTIFICATION_CHAR_LIMIT: 40,
  POS_NOTIFICATION_STATUS_FAILED: 'pos_uploaded_failed',
  POS_NOTIFICATION_STATUS_PARTIALLY: 'pos_uploaded_partially',
  POS_NOTIFICATION_STATUS_SUCCESS: 'pos_uploaded_success',
  POS_POLICY_ADD_UPDATE_MAPPING: 'add_update_pos_mapping',
  AUDIO_CODE_AAC: 'aac',
  ACTIVE_USER: 'ACTIVE',
  ONBOARDING: 'ONBOARDING',
  DAY_IN_MILLISECONDS: 60 * 60 * 24 * 1000,
  BANDWIDTH_DATE_FORMAT: 'MMM Do, YYYY, h:mm A',
  BANDWIDTH_PAGE_SIZE: 10,
  LICENSE_EXPIRING_SOON_LIMIT: 30,
  LICENSE_WRAPPER_LABEL_LIMIT: 30,
  DAYS: constants.DAYS_LABEL,
  RANGE_SLIDER_THUMB_MAX: 1.2,
  RANGE_SLIDER_THUMB_MIN: 7,
  SD_CARD_STATUS: 'Recording Will Start Soon',
  RESOURCE_STATUS_SD_CARD: 'backup/local-storage/status',
  APP_STORE_LINK: 'https://apps.apple.com/us/app/oncloud/id6474283981',
  GOOGLE_PLAY_LINK:
    'https://play.google.com/store/apps/details?id=cloud.hanwhavision.oncloud',
};

const LocalStorageKeysEnum = {
  cameraViewLayout: 'cloud.hanwhavision.oncloud.cameraViewLayouts',
};

const ClipTypeEnum = {
  CLIP_VIDEO_CLIP_AVAILABLE: 'video-clip-available',
  NOTIFICATION_CLIP: 'clip',
  DEVICE_EDGE_RECORDING_CLIP_UPLOAD: 'EDGE_RECORDING_CLIP_UPLOAD',
  DEVICE_CLOUD_STORAGE_ARCHIVES: 'CLOUD_STORAGE_ARCHIVES',
  DEVICES_CLIP_ONLINE_CONNECTION_STATUS: 'online',
  CREATE_CLIP_CLOUD_STORAGE_ARCHIVES: 'CLOUD_STORAGE_ARCHIVES',
  CREATE_CLIP_EDGE_RECORDING_CLIP_UPLOAD: 'EDGE_RECORDING_CLIP_UPLOAD',
  CREATE_CLIP_IS_CLIP_AVAILABLE: 'local-storage/rec-available',
};

const DeviceStatusEnum = {
  ADDED_N_CLAIMED: 'Claimed',
  ADDED_NOT_CLAIMED: 'Pending Claimed',
  ALREADY_ASSIGNED: 'Already Assigned',
  AUTHENTICATED: 'Add Device',
  DEACTIVATED: 'Reclaim Device',
  NOT_AUTHENTICATED: 'Authenticate',
  CON_OFFLINE: 'Offline',
  SELECT_ALL: 'selectAll',
};

const cameraWallEnum = {
  cameraFilter: [
    {
      name: 'Online',
      Id: 'online',
    },
    {
      name: 'Offline',
      Id: 'offline',
    },
  ],
  online_sm: 'online',
  offline_sm: 'offline',
  all_sm: 'all',
  online_cap: 'Online',
  offline_cap: 'Offline',
  all_cap: 'All',
};

const DeviceTypeEnum = {
  IPCam: 'IPCAM',
  NVR: 'NVR',
};

const recordingTypes = {
  DIRECT_TO_CLOUD: 'DIRECT_TO_CLOUD',
  EDGE_RECORDING: 'EDGE_RECORDING',
  CLOUD_BACKUP: 'CLOUD_BACKUP',
};

const EntitlementsTypeEnum = {
  CLOUD_STORAGE_CVR: 'CLOUD_STORAGE_CVR',
  LIVE_VIEW: 'LIVE_VIEW',
  BITRATE: 'BITRATE',
  RESOLUTION: 'RESOLUTION',
  FPS: 'FPS',
  EDGE_STORAGE_CVR: 'EDGE_STORAGE_CVR',
  EDGE_CVR_BACKUP: 'EDGE_CVR_BACKUP',
};

const IncidentTypeEnum = {
  INCIDENT_VIDEO_CLIP: 'incident-video-clip-available',
  INCIDENT_ZIP_CLIP: 'incident-zip-available',
  NOTIFICATION_TYPE: 'incident',
  INCIDENT_DETAIL_MAX_LENGTH: 500,
};

const IncidentStatusEnum = {
  INCIDENT_STATUS_REOPEN: 'reopen',
  INCIDENT_STATUS_CLOSE: 'close',
  INCIDENT_STATUS_REOPENED: 'reopened',
  INCIDENT_STATUS_CLOSED: 'closed',
};

const LicenseStatuses = {
  ACTIVE: 'ACTIVE',
  ACTIVE_UNASSIGNED: 'ACTIVE_UNASSIGNED',
  ASSIGNED_ACTIVATION_PENDING: 'ASSIGNED_ACTIVATION_PENDING',
  EXPIRED: 'EXPIRED',
  UNASSIGNED: 'UNASSIGNED',
  EDGELICENSE: 'edgeLicense',
};

const LicenseType = {
  REGULAR: 'REGULAR',
  ADD_ON: 'ADD_ON',
};

const LineDirectionEnum = {
  LEFT: 1,
  RIGHT: 2,
  BOTH: 3,
};

const OfferingTypeEnum = {
  EVAL: 'EVAL',
  ONBOARDING: 'ONBOARDING',
  PAID: 'PAID',
};

const RolesEnum = {
  ROLE0VMS: 'role0#vms',
  ROLE1VMS: 'role1#vms',
  ROLE2VMS: 'role2#vms',
  ROLE3VMS: 'role3#vms',
  ROLE4VMS: 'role4#vms',
  ROLE5VMS: 'role5#vms',
};

const ServiceTypeEnum = {
  CLOUD_SERVICE: 'oncloud-service',
  CLOUD_STORAGE: 'cloud-storage',
  DM_PRO_SERVICE: 'dmpro-service',
  FLEXAI_SERVICE: 'flexai-service',
  SALESHUB_SERVICE: 'saleshub-service',
  SIGHT_MIND_SERVICE: 'sightmind-service',
  VMS_SERVICE: 'vms-service',
};

const CacheNameEnum = {
  CLIPS_CACHE: 'clips-snapshots',
  EVENTS_CACHE: 'events-snapshots',
  CAMERA_DETAILS_EVENTS_CACHE: 'camera-details-events-snapshots',
};

const EventType = {
  VEHICLE: constants.EVENT_TYPE_VEHICLE,
  OBJ_DETECTION: constants.EVENT_TYPE_OBJ_DETECTION,
  OBJ_TYPE: constants.EVENT_TYPE_OBJ_TYPE,
  CATEGORIES: constants.EVENT_TYPE_CATEGORIES,
  SUB_CATEGORIES: constants.EVENT_TYPE_SUB_CATEGORIES,
  SUB_OBJ_CATEGORIES: constants.EVENT_TYPE_SUB_OBJ_CATEGORIES,
};

const LocalUIHttp = {
  DEVICE_ACCESS_UI_STATUS: 'device/access-ui/status',
  STATUS_ACTIVE: 'active',
  DEVICE_ACCESS_UI: 'device/access-ui',
  ACTION_IS: 'is',
  ACTION_ERROR: 'error',
  DEVICE_ACCESS_UI_DISCONNECT: 'device/access-ui/disconnect',
  STATUS_DISCONNECTED: 'disconnected',
  KEEP_ALIVE_RESOURCE: 'camera/events/proxy-events',
  IN_ACTIVE_STATUS: 'inactive',
  STATUS_IN_PROGRESS: 'IN_PROGRESS',
  STATUS_AVAILABLE: 'AVAILABLE',
  STATUS_ERROR: 'ERROR',
};

const EstimateTypesEnum = {
  BANDWIDTH_ESTIMATE: 'Bandwidth Estimate',
  STORAGE_ESTIMATE: 'Storage Estimate',
};

const cgrResource = [
  'device/info/networkIf',
  'device/info/hwInfo',
  'device/info/camStorage/summary',
  'device/info/camStorage/details',
  'drive/mgmt/internalDrive',
];

const customEventName = [
  'ai.duclo.MotionDetected',
  'ai.duclo.virtualLineDetected',
  'ai.duclo.Intrusion',
  'ai.duclo.Appear/Disappear',
  'ai.duclo.Enter',
  'ai.duclo.Exit',
  'ai.duclo.Loitering',
];

const allEventNames = [
  'ai.duclo.MotionDetected',
  'ai.duclo.virtualLineDetected',
  'ai.duclo.Intrusion',
  'ai.duclo.Appear/Disappear',
  'ai.duclo.Enter',
  'ai.duclo.Exit',
  'ai.duclo.Loitering',
  'ai.duclo.Tampering',
  'ai.duclo.ShockDetection',
  'ai.duclo.FogDetection',
  'ai.duclo.DefocusDetection',
];

const GridSizeEnum = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

const EventsPerPageEnum = {
  LARGE: 27,
  MEDIUM: 28,
  SMALL: 30,
};

const getVirtualArea = () => {
  const area = {
    'va-enter': 'virtual-area-entering',
    'va-exit': 'virtual-area-exiting',
    intrusion: 'virtual-area-intrusion',
    loitering: 'virtual-area-loitering',
    'appear-disappear': 'virtual-area-appear-disappear',
    'motion-start': 'md-include-area',
  };
  return area;
};

const EncodingTypes = {
  MJPEG_TYPE: 'mjpeg',
  H264_TYPE: 'h264',
  H265_TYPE: 'h265',
};

const deviceBitrateOptions = [
  {
    planId: '2mp',
    name: '1.5 Mbps HQ (2 MP)',
    bitrate: 1.5,
  },
  {
    planId: '4mp',
    name: '2.5 Mbps HQ (4 MP)',
    bitrate: 2.5,
  },
  {
    planId: '5mp',
    name: '3.0 Mbps HQ (5 MP)',
    bitrate: 3.0,
  },
  {
    planId: '6mp',
    name: '3.5 Mbps HQ (6 MP)',
    bitrate: 3.5,
  },
  {
    planId: '8mp',
    name: '4.0 Mbps HQ (8/9 MP)',
    bitrate: 4.0,
  },
  {
    planId: 'custom',
    name: 'Custom',
    bitrate: 1.0,
  },
];
const deviceStorageOptions = [
  { id: 'none', value: 'None', actualValue: 0 },
  { id: '128gb', value: '128 GB', actualValue: 128 },
  { id: '256gb', value: '256 GB', actualValue: 256 },
  { id: '512gb', value: '512 GB', actualValue: 512 },
  { id: '1tb', value: '1.0 TB', actualValue: 1024 },
];
const SQ_Constant = 0.7;
const GB_Per_MBPS = 10.8;

const streamingEnum = {
  PLAYBACK_DURATION_EDGE: 30000,
  PLAYBACK_DURATION_CLOUD: 60000,
  RECENT_PLAYBACK_INTERVAL: 10000,
  RT_EVENTS_INTERVAL: 5000,
  REMOVE_BUFFER_DIFF: 4500, // 60 === 1 minutes, 4500 === 1 hour 15 minutes
  REMOVE_BUFFER_TIME: 3600, // 3600 === 1 hour
};

export const regexAnalytics = /^[a-zA-Z0-9]+$/;
export const manageTagName = /[^a-zA-Z0-9]|[`'"&\\/()@*$|%~]|\u00A0|\s/;
export const replaceManageTagName = /[^a-zA-Z0-9]|[`'"&\\/()@*$|%~]|\u00A0|\s/g;

// Please ensure the export list is in alphabetical order
export {
  allEventNames,
  AppDefaults,
  CacheNameEnum,
  cameraWallEnum,
  cgrResource,
  ClipTypeEnum,
  customEventName,
  DeviceStatusEnum,
  DeviceTypeEnum,
  EncodingTypes,
  EntitlementsTypeEnum,
  EventsPerPageEnum,
  EventType,
  getVirtualArea,
  GridSizeEnum,
  IncidentStatusEnum,
  IncidentTypeEnum,
  LicenseStatuses,
  LicenseType,
  LineDirectionEnum,
  LocalStorageKeysEnum,
  LocalUIHttp,
  OfferingTypeEnum,
  recordingTypes,
  RolesEnum,
  ServiceTypeEnum,
  EstimateTypesEnum,
  deviceBitrateOptions,
  deviceStorageOptions,
  SQ_Constant,
  GB_Per_MBPS,
  streamingEnum,
};
